var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "layer-tree-item",
      attrs: { "data-layer-id": _setup.getLayerId(_vm.value) },
    },
    [
      !(_setup.isPageEps && _setup.shouldHideWrapper)
        ? _c(_setup.itemComponent, {
            tag: "component",
            attrs: { item: _vm.value, collapsed: _setup.isCollapsed },
            on: { "toggle-collapse": _setup.toggleCollapse },
          })
        : _c("div", { staticStyle: { padding: "1px 0" } }),
      _vm._v(" "),
      !_setup.isCollapsed || _setup.forceShowIfOnlyHasOnePageEps
        ? [
            _c(
              _setup.draggable,
              _vm._b(
                {
                  attrs: {
                    list: _setup.itemChildren,
                    group: {
                      name: "layers-tree",
                      pull: true,
                    },
                    move: _setup.onMove,
                  },
                  on: {
                    end: _setup.handleDragEnd,
                    input: _setup.emitModelUpdate,
                    change: _setup.onChangeHandler,
                  },
                },
                "draggable",
                _setup.dragOptions,
                false
              ),
              [
                _setup.hasChildren && _setup.itemChildren
                  ? _vm._l(_setup.itemChildren, function (child, index) {
                      return _c(_setup.LayersTreeItem, {
                        key: _setup.getItemKey(child),
                        model: {
                          value: _setup.itemChildren[index],
                          callback: function ($$v) {
                            _vm.$set(_setup.itemChildren, index, $$v)
                          },
                          expression: "itemChildren[index]",
                        },
                      })
                    })
                  : [
                      _c("div", { staticClass: "no-children" }, [
                        _vm._v("This is empty"),
                      ]),
                    ],
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }